import { generateImageUrl } from '../../../helpers/generateImageUrl';
import { Container } from '../../Container/Container';
import styles from './CompanyPage.module.scss';

const CompanyPage = () => {
  return (
    <div className={styles.CompanyPage}>
      <Container>
        <h1>О Groupe SEB</h1>
        <div className={styles.content_holder}>
          <div className={styles.text_holder}>
            <p>
              Groupe SEB — мировой лидер в производстве мелкой бытовой техники и
              кухонной посуды.
              <br /> В портфель компании входят такие известные бренды, как
              Tefal, Rowenta, Krups, Moulinex, WMF, Lagostina и другие.
            </p>
            <p>
              Более чем за 150 лет существования Groupe SEB накопила уникальный
              опыт в области разработки, производства и распространения
              продукции, обеспечивая высокое качество и надёжность.
            </p>
            <p>
              Мы стремимся предоставлять нашим клиентам не только продукты, но и
              полную техническую поддержку — от инструкций до сервисной
              информации о каждой модели.
            </p>
          </div>

          <div className={styles.image_holder}>
            <div className={styles.img}>
              <img
                src={generateImageUrl('seb_about_pic.png')}
                alt="company image"
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CompanyPage;
